import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Ref, useFormContext, Controller } from 'react-hook-form';
import { makeStyles, TextField } from '@material-ui/core';
import { RootState } from '@modules/index';
import { colorSet } from '@components/Provider';
import FormInputLayout from '../Layout/FormInputLayout';
import { RequestInputCommonProps } from './types';

const ProjectNameInput = React.forwardRef<Ref, RequestInputCommonProps>(
  ({ error }, ref) => {
    const projectNameDefaultValue = useSelector<RootState>(
      (state) => state.request.projectName
    ) as string;
    const { projectNameInput } = useStyles();
    const [valueLength, setValueLength] = useState<number>(0);
    const { trigger, control } = useFormContext();

    useEffect(() => {
      if (projectNameDefaultValue) {
        setValueLength(projectNameDefaultValue.length);
        trigger('projectName');
      }
    }, [projectNameDefaultValue, trigger]);

    return (
      <FormInputLayout
        label="프로젝트명"
        required={true}
        valueLength={valueLength}
        limit={20}
      >
        <Controller
          control={control}
          name="projectName"
          render={(render) => (
            <TextField
              {...render}
              onChange={(e) => {
                setValueLength(e.currentTarget.value.length);
                render.onChange(e.target.value.trimStart());
              }}
              data-cy="rfq-projectName"
              autoComplete="off"
              className={projectNameInput}
              variant="outlined"
              error={!!error}
              helperText={error}
              fullWidth
              placeholder="최대 20자로 프로젝트의 이름을 설명해주세요."
            />
          )}
        />
      </FormInputLayout>
    );
  }
);

export default ProjectNameInput;

const useStyles = makeStyles((theme) => ({
  projectNameInput: {
    '& input': {
      padding: 12,
      textAlign: 'left'
    },
    '& .MuiInputBase-root': {
      alignItems: 'center',
      borderRadius: 8
    },
    '& ::placeholder': {
      color: colorSet.gray500
    }
  }
}));
